import type { BreadcrumbItem } from '@/components/Breadcrumb/types'

export const preCallTestSimpleBreadcrumbList: BreadcrumbItem[] = [
  {
    route: '/',
    label: 'Início',
  },
  {
    route: '/teste-de-chamada',
    label: 'Teste de chamada',
    active: true,
  },
]
export const preCallTestSpecialitiesBreadcrumbList: BreadcrumbItem[] = [
  {
    route: '/',
    label: 'Início',
  },
  {
    route: '/atendimento-imediato/especialidades',
    label: 'Especialidades',
  },
  {
    route: '/teste-de-chamada',
    label: 'Teste de chamada',
    active: true,
  },
]
